import { render, staticRenderFns } from "./EdInstagramDestination.vue?vue&type=template&id=43e722c0&"
import script from "./EdInstagramDestination.vue?vue&type=script&lang=js&"
export * from "./EdInstagramDestination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports